/*

 +-++-++-++-++-++-++-++-++-++-++-++-++-+
 |Q||u||a||r||t||e||r||M||a||s||t||e||r|
 +-++-++-++-++-++-++-++-++-++-++-++-++-+

 Interceptor for rewards

 */

import { get } from 'lodash';

export const rewardInterceptor = response => {
  const activity =
    get(response, 'data.activity', undefined) ||
    get(response, 'data.data.activity', undefined) ||
    get(response, 'data.activity_data', undefined) ||
    get(response, 'data.data.activity_data', undefined);
  // if (activity) rewardAction(activity);
};
